import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { deleteAuctionCategory } from 'api/campaigns';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { campaignQueryKeys } from 'queries/campaign-query-keys';
import { queryClient } from 'queries/queryClient';
import { GivebutterAxiosError } from 'types/error';

const useDeleteAuctionCategoryMutation = (
    options: UseMutationOptions<any, GivebutterAxiosError, number, unknown> = {},
) => {
    const { onSuccess } = options;
    const toast = useToast();
    const { data: campaign } = useCurrentCampaign();
    const campaignId = campaign?.id!;
    const auctionId = campaign?.auction_id!;

    return useMutation({
        mutationFn: (categoryId: number) =>
            deleteAuctionCategory(campaignId, auctionId, categoryId),
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: campaignQueryKeys.auctionCategories(campaignId, auctionId),
            });
            onSuccess?.(data, variables, context);
            toast.success('Deleted category');
        },
        onError: (error: GivebutterAxiosError) => {
            toast.error(
                <>{error.response?.data.message ?? 'Unknown error adding auction item category'}</>,
            );
        },
    });
};

export { useDeleteAuctionCategoryMutation };
